@if (!hasQuery()) {
  <p class="nv-search-results__hint">Search by table number, guest name, order id, item name...</p>
} @else if (!hasResults()) {
  <p class="nv-search-results__hint">No matches for "{{ query() }}".</p>
} @else {
  @if (tableMatches().length > 0) {
    <div class="nv-search-results__group">
      <span class="nv-search-results__label">Tables</span>
      @for (status of tableMatches(); track status.tableId) {
        <button type="button" class="nv-search-results__row" (click)="openTable(status)">
          <nv-icon [size]="16">table_restaurant</nv-icon>
          <span class="nv-search-results__row-text">
            <span class="nv-search-results__row-title">Table {{ status.number }}</span>
            @if (status.occupied) {
              <span class="nv-search-results__row-sub">{{ status.guestName || 'Guest seated' }}</span>
            } @else {
              <span class="nv-search-results__row-sub">Free</span>
            }
          </span>
        </button>
      }
    </div>
  }

  @if (orderMatches().length > 0) {
    <div class="nv-search-results__group">
      <span class="nv-search-results__label">Orders</span>
      @for (match of orderMatches(); track match.order.id) {
        <button type="button" class="nv-search-results__row" (click)="goToOrders()">
          <nv-icon [size]="16">receipt_long</nv-icon>
          <span class="nv-search-results__row-text">
            <span class="nv-search-results__row-title">
              Order #{{ match.order.id.slice(0, 6).toUpperCase() }}
              @if (match.tableNumber !== undefined) {
                · Table {{ match.tableNumber }}
              }
            </span>
            <span class="nv-search-results__row-sub">₹{{ formatPrice(match.order.totalMinor) }}</span>
          </span>
        </button>
      }
    </div>
  }

  @if (menuMatches().length > 0) {
    <div class="nv-search-results__group">
      <span class="nv-search-results__label">Menu items</span>
      @for (item of menuMatches(); track item.id) {
        <button type="button" class="nv-search-results__row" (click)="goToMenu()">
          <nv-icon [size]="16">restaurant_menu</nv-icon>
          <span class="nv-search-results__row-text">
            <span class="nv-search-results__row-title">{{ item.name }}</span>
            <span class="nv-search-results__row-sub">₹{{ formatPrice(item.priceMinor) }}</span>
          </span>
        </button>
      }
    </div>
  }
}
